import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero/Hero';
import FeaturedRooms from '../components/FeaturedRooms/FeaturedRooms';
import Amenities from '../components/Amenities/Amenities';
import Gallery from '../components/Gallery/Gallery';
import Testimonials from '../components/Testimonials/Testimonials';
import Newsletter from '../components/Newsletter/Newsletter';
import { FaAward, FaLeaf, FaHeart, FaArrowRight } from 'react-icons/fa';
import './Home.css';

function WhyUs() {
  const items = [
    { icon: FaAward, title: "Award-Winning Luxury", desc: "Recipient of over 25 international hospitality awards for excellence and outstanding guest experience." },
    { icon: FaLeaf, title: "Sustainable Luxury", desc: "Committed to eco-luxury practices — from solar energy to locally sourced cuisine and zero-waste initiatives." },
    { icon: FaHeart, title: "Heartfelt Hospitality", desc: "Our team of 500+ hospitality professionals is dedicated to creating deeply personal, memorable experiences." },
  ];

  return (
    <section className="section why-us-section">
      <div className="container why-us-inner">
        <div className="why-us-image">
          <motion.img
            src="https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80"
            alt="Hotel Lobby"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          />
          <div className="why-us-badge">
            <strong>30+</strong>
            <span>Years of Excellence</span>
          </div>
        </div>

        <div className="why-us-content">
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="section-badge">Why Choose Us</span>
            <h2 className="section-title" style={{ textAlign: 'left', marginBottom: 0 }}>
              The Grand Luxe <br />Difference
            </h2>
            <div className="gold-line" style={{ margin: '16px 0 24px' }} />
            <p style={{ color: 'var(--text-light)', lineHeight: 1.8, marginBottom: '36px' }}>
              For over three decades, Grand Luxe has redefined the meaning of luxury hospitality.
              We believe that true luxury lies in the details — the freshly cut flowers, the perfectly
              pressed linens, the personalized welcome note waiting in your room.
            </p>

            <div className="why-us-items">
              {items.map(({ icon: Icon, title, desc }) => (
                <div key={title} className="why-us-item">
                  <div className="why-us-icon"><Icon /></div>
                  <div>
                    <h4>{title}</h4>
                    <p>{desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/about" className="btn btn-primary">
              Our Story <FaArrowRight />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

function SpecialOfferBanner() {
  return (
    <section className="offers-banner">
      <div className="offers-banner-bg" />
      <div className="container">
        <motion.div
          className="offers-banner-inner"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div>
            <span className="section-badge" style={{ color: 'var(--primary-light)' }}>Limited Time</span>
            <h2 style={{ color: 'var(--white)', fontFamily: 'var(--font-heading)', fontSize: 'clamp(1.8rem, 3vw, 2.8rem)', margin: '8px 0' }}>
              Exclusive Member Rates
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.75)', maxWidth: '500px', lineHeight: 1.7 }}>
              Save up to 25% on select room categories when you book directly. Includes complimentary breakfast and late checkout.
            </p>
          </div>
          <div className="offers-banner-cta">
            <div className="offer-highlight">
              <strong>25%</strong>
              <span>OFF</span>
            </div>
            <Link to="/offers" className="btn btn-primary">View All Offers</Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <main>
      <Hero />
      <WhyUs />
      <FeaturedRooms />
      <Amenities />
      <SpecialOfferBanner />
      <Gallery />
      <Testimonials />
      <Newsletter />
    </main>
  );
}
